export enum SmartSuggestionCustomAction {
  QUICK_WALK_MODAL = '#quickWalkModal',
  CELEBRATIONS_MODAL = '#celebrationsModal',
}
